import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslatePipeModule } from '../../translate/translate.pipe.module';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { ProjectListComponent } from './project-list.component';
import { SearchModule} from '../../search/search.module';
import {SearchCriteriaModule} from '../searchFilter/search-criteria.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslatePipeModule,
    FormsModule,
    ReactiveFormsModule,
    SearchModule,
    SearchCriteriaModule
  ],
  declarations: [ProjectListComponent],
  providers: [],
  exports: [ProjectListComponent]
})

export class ProjectListModule {

}
